


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Committee } from '../models/committee';
import { committeemember } from '../models/committeemember';
import { committeeReviewer } from '../models/committeeReviewer';
import { Department } from '../models/department';
import { committeepermenantInvitees } from '../models/committeepermenantInvitees';
import { Act } from '../models/act';
import { Employee } from '../models/employee';
@Injectable({
  providedIn: 'root'
})
export class CommitteeService {
  [x: string]: any;
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'committee/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllCommittee(filter: string, pagesize: number, pagenumber: number,filterType : number,MeetingTypeId:any): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllCommittee?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&MeetingTypeId=' + (MeetingTypeId ? MeetingTypeId : '')).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewcommittee(Committee_Id?: string): Observable<Array<Committee>> {
      return this.httpService.get(this.apiEndpoint + '/view_Committee/' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    savecommittee(committee: Committee): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveCommittee/', committee).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    savecommitteemember(committeemember: Array<committeemember>): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveCommitteeMember/', committeemember).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveCommitteePermenantInvitees(committeepermenantInvitees:Array< committeepermenantInvitees>): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveCommitteePermenantInvitees/', committeepermenantInvitees).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    
    saveCommitteeReviewer(committeeReviewer: committeeReviewer): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveCommitteeReviewer/', committeeReviewer).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    deleteCommittee(Committee_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteCommittee/' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000'), Committee_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(ShortName?: string,Committee_Id?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?&ShortName=' + (ShortName ? ShortName : '')+ '&Committee_Id=' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }

    checkEmail(Emailid?: string,DepartmentID?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&DepartmentID=' + (DepartmentID ? DepartmentID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }
    getCommitteeMemberlistByCommitteId(Committee_Id?: string): Observable<Array<committeemember>> { 
      return this.httpService.get(this.apiEndpoint + '/getCommitteeMemberlistByCommitteId/' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {            
        if (result.Success) {        
          return result.Data;
        } else {
          return [];
        }
      }));
    } 


    getCommittePermanentInviteesByCommitteId(Committee_Id?: string): Observable<Array<committeepermenantInvitees>> { 
      return this.httpService.get(this.apiEndpoint + '/getCommittePermanentInviteesByCommitteId/' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {            
        if (result.Success) {        
          return result.Data;
        } else {
          return [];
        }
      }));
    } 


    getCommitteeActlistByCommitteId(Committee_Id?: string): Observable<Array<Act>> { 
      return this.httpService.get(this.apiEndpoint + '/getCommitteeActlistByCommitteId/' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {            
        if (result.Success) {        
          return result.Data;
        } else {
          return [];
        }
      }));
    } 

    getCommitteeOrganizerslistByCommitteId(Committee_Id?: string): Observable<Array<Employee>> { 
      return this.httpService.get(this.apiEndpoint + '/getCommitteeOrganizerslistByCommitteId/' + (Committee_Id ? Committee_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {            
        if (result.Success) {        
          return result.Data;
        } else {
          return [];
        }
      }));
    } 
  
  }

